export const removeAccents = (text: string): string => {
    text = text
        .replace(new RegExp('[áàâã]', 'gi'), 'a')
        .replace(new RegExp('[éèê]', 'gi'), 'e')
        .replace(new RegExp('[íìî]', 'gi'), 'i')
        .replace(new RegExp('[óòôõ]', 'gi'), 'o')
        .replace(new RegExp('[úùû]', 'gi'), 'u')
        .replace(new RegExp('[ç]', 'gi'), 'c')
    return text
}
